import { useEffect, useRef, useState } from 'react';
import { autoUploadPromo } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { enabledMultiTariffUpsale, enabledMultiTariffUpsaleC } from 'reactApp/appHelpers/featuresHelpers/features/multiTariffUpsale';
import { referralProgramTariffs } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { SPACE_LIST } from 'reactApp/constants/spaceList';
import { AUTOUPLOAD_TOOLTIP_ID } from 'reactApp/sections/QuotaLanding/AutouploadTooltip/AutouploadTooltip';

const tooltipKey = `${AUTOUPLOAD_TOOLTIP_ID}-shown`;

function setSessionTooltipVisibilityStatus() {
    sessionStorage.setItem(tooltipKey, 'true');
}

function getSessionTooltipVisibilityStatus() {
    return sessionStorage.getItem(tooltipKey);
}

export const autoUploadMinimalTariffSpace = SPACE_LIST.gb_256;

let productForTipId = '';
let timeout;

interface TooltipProps {
    isMobile: boolean;
    productSpace: number;
    isSubscription: boolean;
    productId?: string;
    isMultiBasic?: boolean;
    setShowFamilyStartTooltip?: (_) => void;
}

export const useTooltip = ({
    isMobile,
    productSpace,
    isSubscription,
    productId,
    isMultiBasic = false,
    setShowFamilyStartTooltip,
}: TooltipProps) => {
    const referralProduct = productId && referralProgramTariffs?.month?.includes(productId);
    const upsaleProductCBasic = enabledMultiTariffUpsale && enabledMultiTariffUpsaleC && isMultiBasic;
    // tempexp_18708-start
    const [showTooltip, setShowTooltip] = useState<boolean>(false);
    const tooltipRef = useRef<HTMLDivElement | null>(null);
    const isProductTooltip =
        autoUploadPromo && !isSubscription && productSpace >= autoUploadMinimalTariffSpace && !referralProduct && !upsaleProductCBasic;
    const renderTooltip = showTooltip && isProductTooltip;
    // tempexp_18708-end

    const isProductForAutoshow = isMobile ? !productForTipId && isProductTooltip : productSpace === SPACE_LIST.tb_2;

    const cardForAutoshowTooltip =
        autoUploadPromo && isProductForAutoshow && !referralProduct && !isSubscription && !getSessionTooltipVisibilityStatus();

    useEffect(() => {
        if (cardForAutoshowTooltip && !isMobile && !productForTipId) {
            productForTipId = productId || 'default';

            timeout = setTimeout(() => {
                setShowTooltip(true);
                setSessionTooltipVisibilityStatus();
            }, 3000);
        } else if (!timeout && setShowFamilyStartTooltip) {
            setShowFamilyStartTooltip(true);
        }
    }, [cardForAutoshowTooltip, productId]);

    return { setShowTooltip, tooltipRef, renderTooltip, isProductTooltip };
};
